import { compose } from '@wordpress/compose'
import { InnerBlocks } from "@wordpress/block-editor";
import { SelectControl } from "@wordpress/components";
import { Fragment } from "@wordpress/element";
import { select, dispatch } from "@wordpress/data";

import withStylesPreview from "~buildable/higher-order/with-styles-previews";
import withInspectorTabs from "~buildable/higher-order/with-inspector-tabs";
import {
  INSPECTOR_TABS,
  THEME_VARIABLES,
  THEME_VARIABLES_MAP
} from "~buildable/utils/constants";
import { TabNames } from "~buildable/utils/enums";
import TitleSubtitleParagraph
  from "~buildable/components/title-subtitle-paragraph";
import MeetTheTeamDetails from "~buildable/blocks/MeetTheTeam/JS/details";
import getBlockStyleOptions from "~buildable/utils/get-block-style-options";

const renderTabContent = (tab, props) => {
  const { displayBio, modalBgColor } = props.attributes;

  if (tab.name === TabNames.DETAILS) {
    return MeetTheTeamDetails(props);
  } else if (tab.name === TabNames.STYLE && displayBio === "modal") {
    const { setAttributes } = props;

    const options = THEME_VARIABLES;
    const map = THEME_VARIABLES_MAP;

    let selectedModalBgColorStyle = {};
    if (modalBgColor) {
      selectedModalBgColorStyle.backgroundColor = map[modalBgColor];
    }

    const append = (
      <Fragment>
        <div className="color-select modal-bg-color">
          <SelectControl
            label="Modal Background Color"
            value={ modalBgColor }
            options={ options }
            onChange={ modalBgColor => setAttributes({ modalBgColor }) }
          />
          <div
            className="color-circle"
            style={ selectedModalBgColorStyle }
          />
        </div>
      </Fragment>
    );

    return getBlockStyleOptions(
      props,
      [],
      { append }
    );
  }

  return null;
}

const edit = props => {
  console.log("meet-the-team edit", props);
  const {
    clientId,
    setAttributes
  } = props;

  const {
    title,
    subtitle,
    paragraph,
    hideTitleCard,
    imageAspectRatio,
    displayNameAndJobTitle,
    displayBio,
    modalBgColor,
    innerBlockIds,
    accentColor
  } = props.attributes;

  const innerBlocks = select("core/editor").getBlocksByClientId(clientId)[0].innerBlocks;
  innerBlocks.forEach((block, index) => {
    dispatch("core/editor").updateBlockAttributes(
      block.clientId,
      {
        index,
        parentDisplayNameAndJobTitle: displayNameAndJobTitle,
        parentDisplayBio: displayBio,
        parentModalBgColor: modalBgColor
      }
    )
  });

  const innerCount = innerBlocks.length;
  setAttributes({ innerCount });

  if (innerCount === 0 && innerBlockIds.length > 0) {
    setAttributes({ innerBlockIds: [] });
  }

  const ALLOWED_BLOCKS = ["buildable/meet-the-team-member"];
  const TEMPLATE = [ALLOWED_BLOCKS];

  return (
    <div className={`meet-the-team ${imageAspectRatio} ${displayBio} name-and-job-title-${displayNameAndJobTitle} ${hideTitleCard ? 'hide-title-card' : ''}`}>
      { !hideTitleCard && (
        <div className={`title-card bg-base-theme-${accentColor} with-text`}>
          <TitleSubtitleParagraph
            title={ title }
            subtitle={ subtitle }
            paragraph={ paragraph }
            setAttributes={ setAttributes }
          />
        </div>
      )}

      <InnerBlocks
        allowedBlocks={ ALLOWED_BLOCKS }
        template={ TEMPLATE }
      />
    </div>
  );
};

export default compose(
  withStylesPreview(),
  withInspectorTabs(INSPECTOR_TABS, renderTabContent)
)(edit);
